<div class="attachment-preview-dialog">
  <div class="attachment-preview-dialog__header">
    <div class="attachment-preview-dialog__title" [title]="fileName">
      <ui-svg-icon svgIcon="thread-attachment" size="small"></ui-svg-icon>
      <span>{{ fileName }}</span>
    </div>
    <ui-button
      type="transparent"
      icon="close-cc"
      iconSize="medium"
      class="attachment-preview-dialog__close"
      (click)="close()"
      [matTooltip]="'smart_inbox.inbox_view.detail.preview_close' | translate"
      [attr.aria-label]="'smart_inbox.inbox_view.detail.preview_close' | translate"
    ></ui-button>
  </div>

  <div class="attachment-preview-dialog__body">
    <div *ngIf="isLoading" class="attachment-preview-dialog__state">
      <div class="attachment-preview-dialog__spinner"></div>
      <p>{{ 'smart_inbox.inbox_view.detail.preview_loading' | translate }}</p>
    </div>

    <div *ngIf="!isLoading && hasError" class="attachment-preview-dialog__state">
      <p>{{ 'smart_inbox.inbox_view.detail.preview_failed' | translate }}</p>
      <ui-button
        type="primary"
        [label]="'smart_inbox.inbox_view.detail.preview_retry' | translate"
        (click)="retry()"
      ></ui-button>
    </div>

    <iframe
      *ngIf="!isLoading && !hasError && pdfUrl"
      class="attachment-preview-dialog__pdf"
      [src]="pdfUrl"
      [title]="fileName"
    ></iframe>

    <app-files-previewer
      *ngIf="!isLoading && !hasError && !pdfUrl && previewData.length > 0"
      [data]="previewData"
      [isNotExport]="true"
    >
    </app-files-previewer>
  </div>
</div>
